import $ from "jquery";
import Foundation from "./3rd/_zf.js";
//import { hdConfig } from './components/config.js';

import "./components/global.js";
import "./components/lighthouse.js";
import "./components/back-to-top.js";
import "./components/script-loader.js";
import { initMenu } from "./components/menu.js";
import { initSocialShare } from "./components/social-share.js";
//import SimpleBar from 'simplebar';
//import ResizeObserver from 'resize-observer-polyfill';
import { Fancybox } from "@fancyapps/ui";
import AOS from "aos";
//import select2 from 'select2';

//window.ResizeObserver = ResizeObserver;
//select2();

// Styles
import "../sass/3rd/_index.scss";
//import 'simplebar/dist/simplebar.css';
import "@fancyapps/ui/dist/fancybox/fancybox.css";

// DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
  initMenu("nav.nav", ".main-nav");
  initSocialShare("[data-social-share]", {
    intents: ["facebook", "x", "print", "send-email", "copy-link", "web-share"],
  });
  
  AOS.init({
    duration: 800,
    easing: 'ease-in-out',
    once: true,
    mirror: false
  });
});

window.addEventListener('load', function() {
  setTimeout(function() {
    AOS.refresh();
  }, 500);
});

Fancybox.bind(".fcy-popup, .fcy-video, .banner-video a", {});
Fancybox.bind(
  '.wp-block-gallery .wp-block-image a, [id^="gallery-"] a, [data-rel="lightbox"]',
  {
    groupAll: true, // Group all items
  },
);

jQuery(function ($) {
  let header = $("#inside-header");
  let headerHeight = header.outerHeight();
  $(window).on("scroll", function () {
    let scrollTop = $(this).scrollTop();
    if (scrollTop > headerHeight + 100) {
      header.addClass("w-sticky");
    } else {
      header.removeClass("w-sticky");
    }
  });
});

// HEADER
document.addEventListener("DOMContentLoaded", function () {
  const searchButtons = document.querySelectorAll(".dgwt-wcas-search-submit");
  searchButtons.forEach(function (button) {
    button.innerHTML = "Tìm kiếm";
  });
});
// them read-more cho mo ta danh muc
jQuery(document).ready(function () {
  jQuery(".term-tax-custom .term-description").each(function () {
    if (jQuery(this).height() > 300) {
      jQuery(this).after(
        '<a href="#" class="btn_show btn-main bg-white">Xem thêm</a><div class="mask"></div>',
      );
      jQuery(this).attr("data-height", jQuery(this).height() + "px");
      jQuery(this).css({
        height: "300",
      });
    }
  });
  jQuery(".btn_show").click(function (e) {
    e.preventDefault();
    var this_content = jQuery(this)
      .closest(".term-tax-custom")
      .find(".term-description");
    jQuery(this).closest(".term-tax-custom").find(".mask").remove();
    jQuery(this_content).animate(
      {
        height: jQuery(this_content).attr("data-height"),
      },
      500,
    );
    jQuery(this).remove();
  });
  jQuery("#inside-header .search-mb .btn-search").click(function (e) {
    e.preventDefault();
    jQuery("#inside-header .search-mb .main-search").toggleClass("active");
  });
});
// Counter Animation
$(document).ready(function () {
  function animateCounter($el, target) {
    $({ countNum: 0 }).animate(
      { countNum: target },
      {
        duration: 2000,
        easing: "swing",
        step: function () {
          $el.text(Math.floor(this.countNum).toLocaleString("de-DE"));
        },
        complete: function () {
          $el.text(this.countNum.toLocaleString("de-DE"));
        },
      },
    );
  }
  function startCounters() {
    $(".counter").each(function () {
      var $this = $(this);
      var target = parseInt($this.data("target"));
      if (
        !$this.hasClass("counted") &&
        $(window).scrollTop() + $(window).height() > $this.offset().top
      ) {
        animateCounter($this, target);
        $this.addClass("counted");
      }
    });
  }
  $(window).on("scroll", startCounters);
  startCounters();
});

jQuery(document).ready(function ($) {
  // Tìm phần tử chứa văn bản "Show more" và thay thế nó
  $(
    ".section.archive-product form .yith-wcan-filter .yith-wcan-dropdown .dropdown-wrapper a.show-more",
  ).text("Hiển thị thêm");
  // Đổi "All" thành "Tất cả"
  $(".section.archive-product .matching-items li")
    .find("a")
    .each(function () {
      if ($(this).text().trim() === "All") {
        $(this).text("Tất cả");
      }
    });
  $(".section.archive-product .yith-wcan-dropdown")
    .find(".dropdown-label")
    .each(function () {
      if ($(this).text().trim() === "All") {
        $(this).text("Tất cả");
      }
    });
  $(
    ".section.archive-product .yith-wcan-active-filters .yith-wcan-reset-filters",
  ).each(function () {
    if ($(this).text().trim() === "Reset filters") {
      $(this).text("Xoá tất cả");
    }
  });
  // Đảm bảo khi AJAX hoạt động, văn bản vẫn được cập nhật
  $(document).ajaxComplete(function () {
    $(
      ".section.archive-product form .yith-wcan-filter .yith-wcan-dropdown .dropdown-wrapper a.show-more",
    ).text("Hiển thị thêm");
    $(".section.archive-product .matching-items li")
      .find("a")
      .each(function () {
        if ($(this).text().trim() === "All") {
          $(this).text("Tất cả");
        }
      });
    $(".section.archive-product .yith-wcan-dropdown")
      .find(".dropdown-label")
      .each(function () {
        if ($(this).text().trim() === "All") {
          $(this).text("Tất cả");
        }
      });
    $(
      ".section.archive-product .yith-wcan-active-filters .yith-wcan-reset-filters",
    ).each(function () {
      if ($(this).text().trim() === "Reset filters") {
        $(this).text("Xoá tất cả");
      }
    });
  });
});

jQuery(function ($) {
  const $btn = $("#toggle-contact");
  const $list = $("#contact-links");
  // init trạng thái ban đầu
  const initiallyVisible = $list.is(":visible");
  $btn.toggleClass("is-open", initiallyVisible);
  $btn.attr("aria-expanded", initiallyVisible);
  $btn.find(".icon-default").toggle(!initiallyVisible);
  $btn.find(".icon-close").toggle(initiallyVisible);
  $btn.on("click", function (e) {
    e.preventDefault();
    // tính trạng thái sắp tới
    const willOpen = !$btn.hasClass("is-open");
    // đổi class + aria ngay (icon thay đổi ngay lập tức)
    $btn.toggleClass("is-open", willOpen);
    $btn.attr("aria-expanded", willOpen);
    $btn.find(".icon-default").toggle(!willOpen);
    $btn.find(".icon-close").toggle(willOpen);
    // chạy animation (không cần dựa vào :visible ngay lúc này)
    $list.stop(true, false).slideToggle(200);
  });
});

//
// TAB PRODUCT CAT - HOME
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".pt-tabs-nav .pt-tab");
  const panels = document.querySelectorAll(".pt-tab-panel");
  if (!tabs.length) return;
  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      const id = this.dataset.tab;
      tabs.forEach((t) => t.classList.remove("active"));
      panels.forEach((p) => p.classList.remove("active"));
      this.classList.add("active");
      const panel = document.getElementById(id);
      if (panel) panel.classList.add("active");
    });
  });
});

// MENU HEADER
jQuery(document).ready(function ($) {
  $("#inside-header .toggle-menu").on("click", function () {
    $("#inside-header .main-nav-menu").toggleClass("active");
    $(this).closest("#inside-header").toggleClass("active");
  });
});
// =============================================
// AJAX LIVE SEARCH
// =============================================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.getElementById("ajax-search-input");
    const categorySelect = document.getElementById("category_product");
    const resultsContainer = document.getElementById("ajax-search-results");
    const searchBar = document.getElementById("search-filter-bar");
    if (!searchInput || !resultsContainer) return;
    let debounceTimer = null;
    let currentXHR = null;
    function doSearch() {
      const keyword = searchInput.value.trim();
      const category = categorySelect ? categorySelect.value : "";
      if (keyword.length < 2 && !category) {
        hideResults();
        return;
      }
      // Show loading state
      resultsContainer.innerHTML =
        '<div class="ajax-search-results__loading"><div class="spinner"></div><span>Đang tìm kiếm...</span></div>';
      showResults();
      // Cancel previous request
      if (currentXHR) {
        currentXHR.abort();
      }
      const ajaxUrl =
        typeof window.hdConfig !== "undefined"
          ? window.hdConfig._ajaxUrl
          : "/wp-admin/admin-ajax.php";
      const nonce =
        typeof window.hdConfig !== "undefined"
          ? window.hdConfig._csrfToken
          : "";
      currentXHR = new XMLHttpRequest();
      currentXHR.open("POST", ajaxUrl, true);
      currentXHR.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded",
      );
      currentXHR.onload = function () {
        if (currentXHR.status === 200) {
          try {
            const response = JSON.parse(currentXHR.responseText);
            if (response.success && response.data.html) {
              resultsContainer.innerHTML = response.data.html;
              showResults();
            } else {
              resultsContainer.innerHTML =
                '<div class="ajax-search-results__empty"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg><p>Không tìm thấy sản phẩm nào</p></div>';
              showResults();
            }
          } catch (e) {
            hideResults();
          }
        }
      };
      currentXHR.onerror = function () {
        hideResults();
      };
      const params = new URLSearchParams({
        action: "ajax_product_search",
        keyword: keyword,
        category: category,
        _wpnonce: nonce,
      });
      currentXHR.send(params.toString());
    }
    function showResults() {
      resultsContainer.classList.add("active");
      searchBar.classList.add("search-active");
    }
    function hideResults() {
      resultsContainer.classList.remove("active");
      searchBar.classList.remove("search-active");
      resultsContainer.innerHTML = "";
    }
    // Input event with debounce
    searchInput.addEventListener("input", function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(doSearch, 400);
    });
    // Category change triggers search
    if (categorySelect) {
      categorySelect.addEventListener("change", function () {
        clearTimeout(debounceTimer);
        doSearch();
      });
    }
    // Focus event - re-show results if there's content
    searchInput.addEventListener("focus", function () {
      if (resultsContainer.innerHTML.trim()) {
        showResults();
      }
    });
    document.addEventListener("click", function (e) {
      if (!searchBar.contains(e.target)) {
        hideResults();
      }
    });
    // Escape key to close
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        hideResults();
        searchInput.blur();
      }
    });

    // Keyboard navigation in results
    searchInput.addEventListener("keydown", function (e) {
      const items = resultsContainer.querySelectorAll(".ajax-search-item");
      if (!items.length) return;

      const activeItem = resultsContainer.querySelector(
        ".ajax-search-item.is-highlighted",
      );
      let index = Array.from(items).indexOf(activeItem);

      if (e.key === "ArrowDown") {
        e.preventDefault();
        index = index < items.length - 1 ? index + 1 : 0;
        items.forEach((it) => it.classList.remove("is-highlighted"));
        items[index].classList.add("is-highlighted");
        items[index].scrollIntoView({ block: "nearest" });
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        index = index > 0 ? index - 1 : items.length - 1;
        items.forEach((it) => it.classList.remove("is-highlighted"));
        items[index].classList.add("is-highlighted");
        items[index].scrollIntoView({ block: "nearest" });
      } else if (e.key === "Enter" && activeItem) {
        e.preventDefault();
        window.location.href = activeItem.getAttribute("href");
      }
    });
  });
})();

// =============================================
// MOBILE AJAX SEARCH (Off-Canvas)
// =============================================
(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const searchInput = document.getElementById("mobile-search-input");
    const resultsContainer = document.getElementById("mobile-search-results");
    const searchBar = document.getElementById("mobile-search-bar");

    if (!searchInput || !resultsContainer) return;

    let debounceTimer = null;
    let currentXHR = null;

    function doSearch() {
      const keyword = searchInput.value.trim();

      if (keyword.length < 2) {
        hideResults();
        return;
      }

      // Show loading
      resultsContainer.innerHTML =
        '<div class="ajax-search-results__loading"><div class="spinner"></div><span>Đang tìm kiếm...</span></div>';
      showResults();

      // Cancel previous request
      if (currentXHR) {
        currentXHR.abort();
      }

      const ajaxUrl =
        typeof window.hdConfig !== "undefined"
          ? window.hdConfig._ajaxUrl
          : "/wp-admin/admin-ajax.php";
      const nonce =
        typeof window.hdConfig !== "undefined"
          ? window.hdConfig._csrfToken
          : "";

      currentXHR = new XMLHttpRequest();
      currentXHR.open("POST", ajaxUrl, true);
      currentXHR.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded",
      );

      currentXHR.onload = function () {
        if (currentXHR.status === 200) {
          try {
            const response = JSON.parse(currentXHR.responseText);
            if (response.success && response.data.html) {
              resultsContainer.innerHTML = response.data.html;
              showResults();
            } else {
              resultsContainer.innerHTML =
                '<div class="ajax-search-results__empty"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg><p>Không tìm thấy sản phẩm nào</p></div>';
              showResults();
            }
          } catch (e) {
            hideResults();
          }
        }
      };

      currentXHR.onerror = function () {
        hideResults();
      };

      const params = new URLSearchParams({
        action: "ajax_product_search",
        keyword: keyword,
        category: "",
        _wpnonce: nonce,
      });

      currentXHR.send(params.toString());
    }

    function showResults() {
      resultsContainer.classList.add("active");
      searchBar.classList.add("search-active");
    }

    function hideResults() {
      resultsContainer.classList.remove("active");
      searchBar.classList.remove("search-active");
      resultsContainer.innerHTML = "";
    }

    // Input with debounce
    searchInput.addEventListener("input", function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(doSearch, 400);
    });

    // Escape to close
    searchInput.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        hideResults();
        searchInput.blur();
        return;
      }

      // Keyboard navigation
      const items = resultsContainer.querySelectorAll(".ajax-search-item");
      if (!items.length) return;

      const activeItem = resultsContainer.querySelector(
        ".ajax-search-item.is-highlighted",
      );
      let index = Array.from(items).indexOf(activeItem);

      if (e.key === "ArrowDown") {
        e.preventDefault();
        index = index < items.length - 1 ? index + 1 : 0;
        items.forEach((it) => it.classList.remove("is-highlighted"));
        items[index].classList.add("is-highlighted");
        items[index].scrollIntoView({ block: "nearest" });
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        index = index > 0 ? index - 1 : items.length - 1;
        items.forEach((it) => it.classList.remove("is-highlighted"));
        items[index].classList.add("is-highlighted");
        items[index].scrollIntoView({ block: "nearest" });
      } else if (e.key === "Enter" && activeItem) {
        e.preventDefault();
        window.location.href = activeItem.getAttribute("href");
      }
    });
  });
})();
